module.exports = __webpack_public_path__ + "img/melanina.585b2cdc.webp";